<template>
  <div>
    <div class="row mx-0 px-0 d-xl-flex justify-content-between col-12 mb-3">
      <div class="row mx-0 d-sm-flex px-0 col-xl-9 text-xs">
        <div class="col-xl-1 px-0 col-sm-3 d-flex">
          <strong class="color-main">Fecha Actual</strong>
        </div>
        <div class="col-xl-2 col-sm-9 px-0">
          <input
            :value="medical_evolutions.date"
            type="date"
            class="form-control form-control-input form-control-sm"
            readonly
          />
        </div>
        <div class="col-xl-1 col-sm-3 px-0 ms-xl-4 d-flex">
          <strong class="color-main">Hora</strong>
        </div>
        <div class="col-xl-2 col-sm-9 px-0">
          <input
            :value="medical_evolutions.hour"
            type="time"
            class="form-control form-control-input form-control-sm"
            readonly
          />
        </div>
        <div class="col-xl-2 col-sm-3 px-0 ms-xl-4 d-flex">
          <strong class="color-main">Dias Hospitalizados</strong>
        </div>
        <div class="col-xl-2 col-sm-9 px-0">
          <input
            :value="medical_evolutions.day"
            type="text"
            class="form-control form-control-input form-control-sm"
            readonly
          />
        </div>
      </div>
      <div class="col-xl-3 text-xs px-0 mt-xl-0 mt-2">
        <div class="row mx-0 px-0">
          <div class="col-xl-3 px-0 col-sm-3">
            <strong class="color-main">Medico</strong>
          </div>
          <div class="col-xl-9 col-sm-9 px-0">
            <input
              :value="medical_evolutions.doctor_name"
              type="text"
              class="form-control form-control-input form-control-sm"
              readonly
            />
          </div>
        </div>
      </div>
    </div>

    <div class="row mx-0 px-0">
      <div class="col-xl-2 px-0">
        <div class="text-center py-1 border border-main border-2">
          <strong class="color-main">Signos Vitales</strong>
        </div>
        <div class="border border-2 border-main py-2 px-1">
          <div
            class="row mx-0 px-0 d-sm-flex color-main fw-bold"
            v-for="(signoVital, index1) in medical_evolutions.vital_sings"
            :key="index1"
          >
            <div class="col-xl-7 col-sm-3 text-xs">
              <span>{{ signoVital.label }}</span>
            </div>
            <div class="col-xl-5 col-sm-9 pb-1 px-0" v-if="signoVital.label != 'PAM'">
              <input
                :value="signoVital.value"
                type="text"
                class="form-control form-control-input form-control-sm"
                readonly
              />
            </div>
            <div class="col-xl-5 col-sm-9 pb-1 px-0" v-else>
              <input
                :value="cpValuePam"
                type="text"
                class="form-control form-control-input form-control-sm"
                readonly
              />
            </div>
          </div>
        </div>
      </div>
      <div class="col-xl-10 px-0 h-100">
        <div class="px-xl-1">
          <div class="text-center py-1 border border-3 border-main">
            <strong class="color-main">(S) Subjetivo</strong>
          </div>
          <div class="border border-3 border-main">
            <div class="px-1 py-1">
              <textarea
                :value="medical_evolutions.subjective"
                class="form-control"
                readonly
              ></textarea>
            </div>
          </div>
        </div>
        <div class="px-xl-1 row mx-0 px-0">
          <div class="text-center py-1 border border-3 border-main">
            <strong class="color-main">(O) Objetivo</strong>
          </div>
          <div class="py-1 px-2 border border-2 border-main">
            <div
              class="row mx-0 px-0 d-sm-flex color-main fw-bold pb-1"
              v-for="(objetivo, index4) in medical_evolutions.physical_exam"
              :key="index4"
            >
              <div class="text-start col-xl-3 col-sm-3 px-0 py-1 text-xs">
                <span>{{ objetivo.label }}</span>
              </div>
              <div class="col-xl-9 col-sm-9 px-0">
                <input
                  :value="objetivo.value"
                  type="text"
                  class="form-control form-control-input form-control-sm"
                  style="height: 33.2px"
                  readonly
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row mx-0 px-0 mt-2">
      <div class="col-xl-5 px-0">
        <div class="px-0 px-xl-1">
          <div class="text-center py-1 border border-main border-3">
            <strong class="color-main">(A) Apreciacion</strong>
          </div>
          <div class="border border-main border-3">
            <textarea
              :value="medical_evolutions.appreciation"
              class="form-control border border-0"
              rows="4"
              readonly
            ></textarea>
          </div>
        </div>
      </div>
      <div class="col-xl-7 px-0 h-100">
        <div class="px-0 mt-2 px-xl-1">
          <div class="text-center py-1 border border-main border-3 border-main">
            <strong class="color-main">Diagnostico</strong>
          </div>
          <div class="py-3 px-3 border-3 border-main border">
            <table class="w-100 table table-bordered">
              <caption class="div-text"></caption>
              <thead class="div-text div-title">
                <tr>
                  <th>N°</th>
                  <th>Dx</th>
                  <th>CIE10</th>
                  <th>TIPO</th>
                </tr>
              </thead>
              <tbody v-if="medical_evolutions.diagnostics && medical_evolutions.diagnostics.length" class="div-text">
                <tr
                  v-for="(item1, index) in medical_evolutions.diagnostics"
                  :key="index"
                  class="px-1"
                >
                  <td>{{ index + 1 }}</td>
                  <td>{{ item1.name }}</td>
                  <td>{{ item1.codigo }}</td>
                  <td>{{ item1.type }}</td>
                </tr>
              </tbody>
              <tbody v-else class="div-text">
                <tr>
                  <td colspan="4" class="text-center">No hay diagnosticos</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="px-0 mt-2 px-xl-1">
          <div class="text-center py-1 border border-main border-3">
            <strong class="color-main fw-bold">PLAN</strong>
          </div>
          <div class="border border-main border-3">
            <div class="row mx-0 px-3 py-2">
              <template v-if="medical_evolutions.plan && medical_evolutions.plan.length">
                <div
                  v-for="(planunit, index) in medical_evolutions.plan"
                  :key="index"
                  class="col-md-12 py-1"
                >
                  <div
                    class="input-group input-group btn-home px-0 text-white fw-bold border bg-main h-100 border-2 align-middle"
                  >
                    <span class="w-100 text-start px-2 py-1">{{ planunit.name }}</span>
                  </div>
                </div>
              </template>
              <div v-else class="col-md-12 text-center text-muted py-2">
                <small>No hay planes registrados</small>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "c-asistencial-uciadulto-historia-detallehospi",
  props: {
    medical_evolutions: {
      type: Object,
      required: true,
      default: () => ({}),
    },
  },
  computed: {
    // misma formula que usa EvolucionHospi.vue para PAM,
    // ya que estos datos provienen de una evolucion de origen Hospitalizacion
    cpValuePam() {
      const vital_sings =
        (this.medical_evolutions && this.medical_evolutions.vital_sings) || [];
      let pas = vital_sings[6] ? vital_sings[6].value : "";
      let pas1 = isNaN(pas) || pas === "" || pas === null ? 0 : pas;
      let pad = vital_sings[7] ? vital_sings[7].value : "";
      let pad1 = isNaN(pad) || pad === "" || pad === null ? 0 : pad;
      let dif = parseFloat(parseFloat(pas1) - parseFloat(pad1)) / 3;
      let div = parseFloat(parseFloat(pad1) - dif).toFixed(2);
      return isNaN(div) ? null : div;
    },
  },
};
</script>